import { GoogleOAuthProvider,GoogleLogin } from '@react-oauth/google';
import { useContext} from 'react';
import AuthContext from '../context/GlobalContext';
import jwt_decode from "jwt-decode";
import swal from '../services/swalConfig';
import { useTranslation } from 'react-i18next';

const ButtonLoginWithGoogle = () => {

    const {googleLoginApiCall,setLoading} = useContext(AuthContext);
    const { t, i18n } = useTranslation();

    const showError = () => {
        swal.fire({
            title: t('errors.oops'),
            text: t('errors.login_failed'),
            icon: 'error',
            showCancelButton: false
        });
    };

    const responseMessage = async (response) => {
        setLoading(true)
        try {
            const decoded = jwt_decode(response.credential)

            let dataUser = {
                // ID token Google: diverifikasi API sehingga identitas tidak bisa dipalsukan.
                // Field di bawahnya tetap dikirim untuk kompatibilitas dengan API versi lama.
                credential: response.credential,
                email: decoded.email,
                first_name: decoded.family_name,
                last_name: decoded.given_name,
                profile_picture: decoded.picture
            }

            await googleLoginApiCall(dataUser)
        } catch (error) {
            showError();
        }finally{
            setLoading(false)
        }
    };

    const errorMessage = () => {
        showError();
    };

    return(
        <div className="mb-3 mt-3 container-google-login">
            <GoogleOAuthProvider clientId="184889941455-4ssb5vse8chg07vhop4d3d46e47d9k74.apps.googleusercontent.com">
                <GoogleLogin
                    onSuccess={responseMessage}
                    onError={errorMessage}
                    locale={i18n.language}
                    shape="pill"
                    cookiePolicy={'single_host_origin'}/>
            </GoogleOAuthProvider>
        </div>
    )
}

export default ButtonLoginWithGoogle
